(ns pfo.chat.core (:require
                   [pfo.util :as util]
                   [pfo.chat.component :as component]
                   [pfo.chat.debug :as debug]
                   ))

(defn chat [{:keys [query-params]}]
  (util/set-page #'component/chat query-params))

(defn chat-debug [{:keys [query-params]}]
  (util/set-page #'debug/debug query-params nil))

(defn artifact-download [{:keys [id]}]
  (util/set-page #'component/artifact-download {:id id}))
